export const bitKubMainNet = {
    "nativeCurrency": {
        "name": "KUB",
        "symbol": "KUB",
        "decimals": 18
    },
    "blockExplorerUrls": ["https://kubscan.com"],
    "chainId": `0x${Number(96).toString(16)}`,
    "chainName": "Bitkub Chain",
    "rpcUrls": ["https://rpc.kubchain.io"]
}

export const bitKubTestNet = {
    "nativeCurrency": {
        "name": "tKUB",
        "symbol": "tKUB",
        "decimals": 18
    },
    "blockExplorerUrls": ["https://testnet.kubscan.com"],
    "chainId": `0x${Number(25925).toString(16)}`,
    "chainName": "Bitkub Chain - Testnet",
    "rpcUrls": ["https://rpc-testnet.bitkubchain.io"]
}

export function getChainSetting() {
    console.log("process.env.REACT_APP_ENV_NAME: ", process.env.REACT_APP_ENV_NAME)
    if (process.env.REACT_APP_ENV_NAME === "prod") {
        return bitKubMainNet
    }
    return bitKubTestNet
}

export function getNumericChainId(chainDetail = getChainSetting()) {
    if (!chainDetail || !chainDetail.chainId) {
        return 96;
    }
    if (typeof chainDetail.chainId === "number") {
        return chainDetail.chainId;
    }
    return parseInt(chainDetail.chainId, 16);
}